import type React from 'react';

import { FormField, Label, Select } from '@zillow/constellation-10';

import type { Section } from '../../../models';
import { UNRELATED_PEOPLE } from '../../../constants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

const MAX_ALLOWED_PEOPLE = 4;

// Generate options from 0 to max people
const peopleOptions = Array.from({ length: MAX_ALLOWED_PEOPLE + 1 }, (_, i) => ({
  value: String(i),
  label: `${i} ${i === 1 ? 'person' : 'people'}`,
}));

export default function UnrelatedPeople({ section, setSectionValues }: Props): JSX.Element {
  function onPeopleAllowedChange(event: React.ChangeEvent<HTMLSelectElement>): void {
    setSectionValues({
      [UNRELATED_PEOPLE.FIELD_NAME.PEOPLE_ALLOWED]: Number(event.target.value),
    });
  }

  const allowedPeople = section.getFieldValue(UNRELATED_PEOPLE.FIELD_NAME.PEOPLE_ALLOWED);

  return (
    <>
      <FormField
        required
        label={<Label>How many unrelated people can occupy your property?</Label>}
        control={
          <Select value={String(allowedPeople)} onChange={onPeopleAllowedChange}>
            {peopleOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>
        }
      />
    </>
  );
}

UnrelatedPeople.description = 'Specifically for the City of Boulder.';
